import { render } from "./SonstigesNew.vue?vue&type=template&id=fbfe213c"
import script from "./SonstigesNew.vue?vue&type=script&lang=js"
export * from "./SonstigesNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__